// extracted by mini-css-extract-plugin
export default {"subAdherence":"SubmittedCompletionDurationCell_subAdherence__XRjDH"};